import { motion } from "framer-motion";
import { memo, useState } from "react";
import MissingFile from "../../assets/missingFile.svg";
import "./ItemNotFound.css";

function ItemNotFound({
	label = "Nenhum item foi localizado.",
}: {
	label?: string;
}) {
	const [imageLoaded, setImageLoaded] = useState(false);
	return (
		<motion.div
			key="item-not-found"
			initial={{ opacity: 0 }}
			animate={{ opacity: imageLoaded ? 1 : 0 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
			className="item-not-found"
		>
			<div
				onLoad={() => {
					setImageLoaded(true);
				}}
				style={{
					height: "120px",
				}}
			>
				<img src={MissingFile} alt="Item não encontrado" />
			</div>
			<h2>{label}</h2>
		</motion.div>
	);
}

export default memo(ItemNotFound);
